<template>
  <div v-if="visible" class="refund-modal-overlay" @click="handleOverlayClick">
    <div class="refund-modal" @click.stop>
      <div class="refund-modal-header">
        <h3>退款确认</h3>
        <button class="close-btn" @click="handleCancel">×</button>
      </div>

      <div class="refund-modal-body">
        <div class="order-info">
          <div class="info-item">
            <span class="label">订单号：</span>
            <span class="value">{{ orderInfo.orderNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">退款金额：</span>
            <span class="value amount">¥{{ orderInfo.amount.toFixed(2) }}</span>
          </div>
        </div>

        <div class="refund-reason">
          <label for="refundReason">退款原因（可选）：</label>
          <textarea
            id="refundReason"
            v-model="refundReason"
            placeholder="请输入退款原因..."
            rows="3"
            maxlength="200"
          ></textarea>
          <div class="char-count">{{ refundReason.length }}/200</div>
        </div>
      </div>

      <div class="refund-modal-footer">
        <button class="cancel-btn" @click="handleCancel">取消</button>
        <button class="confirm-btn" @click="handleConfirm" :disabled="loading">
          {{ loading ? '处理中...' : '确认退款' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefundModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderInfo: {
      type: Object,
      required: true
    }
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {
      refundReason: '',
      loading: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.refundReason = ''
        this.loading = false
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm', this.refundReason.trim())
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleOverlayClick() {
      this.handleCancel()
    },
    setLoading(loading) {
      this.loading = loading
    }
  }
}
</script>

<style scoped>
.refund-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.refund-modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.refund-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.refund-modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #262626;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #8c8c8c;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #f5f5f5;
  color: #595959;
}

.refund-modal-body {
  padding: 24px;
}

.order-info {
  background: #fafafa;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item .label {
  color: #595959;
  font-size: 14px;
}

.info-item .value {
  font-weight: 500;
  color: #262626;
}

.info-item .value.amount {
  color: #ff4d4f;
  font-size: 16px;
  font-weight: 600;
}

.refund-reason {
  margin-bottom: 16px;
}

.refund-reason label {
  display: block;
  margin-bottom: 8px;
  color: #262626;
  font-weight: 500;
}

.refund-reason textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
}

.refund-reason textarea:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}

.refund-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.cancel-btn,
.confirm-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
}

.cancel-btn {
  background: white;
  color: #595959;
  border-color: #d9d9d9;
}

.cancel-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}

.confirm-btn {
  background: #1890ff;
  color: white;
  border-color: #1890ff;
  min-width: 80px;
}

.confirm-btn:hover:not(:disabled) {
  background: #40a9ff;
  border-color: #40a9ff;
}

.confirm-btn:disabled {
  background: #f5f5f5;
  color: #8c8c8c;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
</style>